import toggle from '../modules/toggle';
import scroller from '../modules/scroller';
import sticky from '../modules/sticky';
import carousel from '../modules/carousel';
import gaEvents from '../modules/ga-events';
import actions from '../modules/actions';

const Ui = {
  init(element) {
    toggle.init(element);
    scroller.init(element);
    sticky.init(element);
    carousel.init(element);
    gaEvents.init(element);
    actions.init(element);
  },
};

export default Ui;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/go-adventure-blog/src/scripts/utils/ui.js